import dayjs from 'dayjs'
import {formatMonetaryToBr, removeMask} from '../../../../utils/formatMonetaryToBr'

interface IInfoManualPayment {
  value: number
  date: Date
}

const InfoManualPayment = ({value, date}: IInfoManualPayment) => {
  const dateFormat = dayjs(date).format('DD/MM/YYYY')
  return (
    <span className='fw-bold d-block'>
      PGTO Manual: {value} - {dateFormat}
    </span>
  )
}

export {InfoManualPayment}
